// Atomic component for displaying email links
export function EmailLink({ row }) {
  const { email } = row.original;

  if (!email) {
    return "";
  }

  return (
    <a href={`mailto:${email}`} className=" flex items-center gap-1">
      {email}
    </a>
  );
}
